var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "notification",
      class: _vm.notificationClass,
      on: {
        click: function ($event) {
          return _vm.trackNotificationTileClick(_vm.notification.notif_type)
        },
      },
    },
    [
      _c("div", { staticClass: "icon-container" }, [
        _c("i", { staticClass: "icon fa", class: _vm.notificationIcon }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-body" }, [
        _c("div", { staticClass: "text-container" }, [
          _c("p", { staticClass: "lead" }, [
            _vm._v(_vm._s(_vm.notification.heading)),
          ]),
          _vm._v(" "),
          _vm.notification.content
            ? _c("p", { staticClass: "primary" }, [
                _vm._v(_vm._s(_vm.notification.content)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.notification.created_at
            ? _c("p", { staticClass: "sub" }, [_vm._v(_vm._s(_vm.timestamp))])
            : _vm._e(),
          _vm._v(" "),
          !_vm.notification.read_at
            ? _c("span", { ref: "unread-circle", staticClass: "unread-circle" })
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }